import { DynamicStandaloneTextSubtitle } from '@/components/TextSubtitle';
import { LabradorComponent } from '@/types/component';
import { getLabStylingClasses } from '@/utils/getLabStylingClasses';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorTextTitle: LabradorComponent = ({ type, data, meta }) => {
  const { subtitle, fieldSettings } = data;
  const className = getLabStylingClasses(fieldSettings.subtitle);
  return (
    <DynamicStandaloneTextSubtitle
      text={subtitle}
      data-content-index={meta.contentIndex}
      options={{ className }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorTextTitle;
